var map = {
	"./whiteBishop.jpg": "lJa2",
	"./whiteKing.jpg": "lWr3",
	"./whiteKnight.jpg": "+xEM",
	"./whitePone.jpg": "3F3x",
	"./whiteQueen.jpg": "O0RN",
	"./whiteRook.jpg": "VXpb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vvha";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.jpg$
// module id = vvha
// module chunks = 1